import { useEffect, useState } from 'react';
import { css } from '@emotion/react'
import styled from '@emotion/styled'
import EditForm from '../../utils/utilities/EditForm';

import { Grid } from '@mui/material';

import { fields, initialValues, schema, additionalState } from './config';


const EditContactGroup = ({ ignore_id = false, edit_id = null, dialog = false, invalidate_queries = null }) => {
  const [formFields, setFormFields] = useState([...fields.map(field => ({...field}))]);

  return (
    <EditForm title={"Contact Group"} initialValues={initialValues} fields={formFields} schema={schema} url={"contact_groups"} dialog={dialog} ignore_id={ignore_id} edit_id={edit_id} invalidate_queries={invalidate_queries} additionalState={additionalState}>

      
     </EditForm>
  );
}

export default EditContactGroup;